var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',{attrs:{"path":_vm.value.event,"tag":"div"},scopedSlots:_vm._u([{key:"residential",fn:function(){return [(_vm.entry)?_c('a',{attrs:{"href":_vm.entry.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.entry.pagetitle))]):_c('span',[_vm._v(_vm._s(_vm.value.data.residential))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }